import { useState } from "react";

export default function MButton({
  label,
  color = 'primary',
  className,
  onClick,
  disabled
}) {
  return (
    <button disabled={disabled} className={`m-button ${color} ${className ? className : ''}`} onClick={onClick} >
      {label}
    </button>
  );
}
